module.exports = __webpack_public_path__ + "static/img/21-0115-cover.233f5ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/news/21-0115-cover.jpg
// module id = oB+1
// module chunks = 0